import { Button as MuiButton } from '@mui/material';
import { styled } from '@mui/system';

interface StyledButtonProps {
  btnColor?: string;
}

export const StyledButton = styled(MuiButton)<StyledButtonProps>(
  ({ $btnColor, $backgroundColor }) => ({
    maxHeight: '40px',
    color: $btnColor || '#00000099',
    ...($backgroundColor && { backgroundColor: $backgroundColor }),
  }),
);
